<template>
  <div class="module-afiliasi">
    <SOSlotBase :container-name="'terms-page-content'">
      <template v-slot:title-bar>
        <div>
          <SOTitleBar :page-title="'Rekening Tarik Tunai'" :type="'back'" @back="back" />
        </div>
      </template>
      <template v-slot:content>
        <div class="p-x-20">
          <div class="card_breadcrum p-t-16 m-x-min bg-grey">
            <div class="p-x-20">
              <SOHeaderList
                :title="`Pastikan data yang diisi benar guna menghindari kesalahan pada saat tarik tunai/pencairan.`"
              />
            </div>
          </div>
          <div class="form-field d-grid-1">
            <form class="update-rekening">
              <div class="form-group">
                <div class="p-t-16">
                  <SOInputRegular
                    :title="'Nama Pemilik Rekening'"
                    :placeholder="'Nama Pemilik Rekening'"
                    :validation="'alphanumeric'"
                    :required="true"
                    v-model="pemilikRekening"
                  />
                  <ErrorMessage class="error" label="Nama Pemilik Rekening" :validation="$v.pemilikRekening" />
                </div>
                <div class="p-t-16">
                  <SOInputSelect
                    :required="true"
                    :title="'Bank'"
                    :placeholder="'Pilih Nama Bank'"
                    :options="dataListBank"
                    :selected="selectedBank"
                    @option-selected="optionSelected"
                  />
                  <ErrorMessage class="error" label="Nama Pemilik Rekening" :validation="$v.bank" />
                </div>
                <div class="p-t-16">
                  <SOInputNumeric
                    :title="'Nomor Rekening'"
                    :placeholder="'Nomor Rekening'"
                    :required="true"
                    v-model="noRekening"
                    ref="inptNomorRekening"
                  />
                  <ErrorMessage class="error" label="Nama Pemilik Rekening" :validation="$v.noRekening" />
                </div>
              </div>
            </form>
            <div class="btn-save">
              <SOButton
                :primary="true"
                :full="true"
                :text="'Simpan'"
                :id="`afiliasi-btn-save-rekening`"
                :disable="isFetching"
                :loading="isFetching"
                @action="onSave"
              />
            </div>
          </div>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOButton from "@/so-components/global/ui/SOButton";

import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOInputNumeric from "@/so-components/global/input/SOInputNumeric";
import ErrorMessage from "@/component-items/ErrorMessage";

import { minLength, required } from "vuelidate/lib/validators";

import { moduleName } from "../store/state";

export default {
  name: "RekeningSetPage",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOHeaderList,
    SOInputRegular,
    SOInputSelect,
    SOInputNumeric,
    SOButton,
    ErrorMessage,
  },
  data() {
    return {
      pemilikRekening: "",
      noRekening: "",
      bank: "", //Bank ID
      routerBack: "afiliasi.dashboard",
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === "afiliasi.dashboard.withdraw") {
        vm.routerBack = from.name;
      }
    });
  },
  watch: {
    response: function(newRes, oldRes) {
      if (newRes !== oldRes) {
        if (newRes.success === true) {
          this.getDataRekening();
          this.back();
        }
      }
    },
  },
  mounted() {
    this.init();
  },
  validations: {
    pemilikRekening: {
      required,
      minLength: minLength(3),
    },
    bank: {
      required,
    },
    noRekening: {
      required,
      minLength: minLength(8),
    },
  },
  computed: {
    ...mapGetters(moduleName, {
      isFetching: "isFecthing",
      listBank: "listBank",
      response: "getResponse",
      afiliasiSet: "afiliasiSet",
    }),
    selectedBank() {
      return this.bank;
    },
    getRekening() {
      return this.afiliasiSet.rekening;
    },
    dataListBank() {
      let listBank = $.map(this.listBank, function(obj) {
        obj.text = obj.text || obj.nama;

        return obj;
      });
      return listBank;
    },
  },
  methods: {
    ...mapActions({
      getListBank: `${moduleName}/getListBank`,
      updateBank: `${moduleName}/updateBank`,
      getDataRekening: `${moduleName}/getDataRekening`,
    }),
    back() {
      this.$router.push({ name: this.routerBack });
    },
    init() {
      if (this.listBank.length <= 0) {
        this.getListBank();
      }

      if (this.getRekening.id) {
        this.pemilikRekening = this.getRekening.pemilik;
        this.noRekening = this.getRekening.noRekening;
        this.bank = this.getRekening.id;

        this.$refs.inptNomorRekening.nominal.formatted = this.getRekening.noRekening;
        this.$refs.inptNomorRekening.nominal.raw = parseInt(this.getRekening.noRekening);
      }
    },
    optionSelected(e) {
      this.bank = e;
    },
    errorValidation() {
      let { pemilikRekening, noRekening, bank } = this.$v;
      pemilikRekening.$touch();
      noRekening.$touch();
      bank.$touch();

      return pemilikRekening.$invalid || noRekening.$invalid || bank.$invalid;
    },
    async onSave() {
      if (this.errorValidation()) {
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
        return;
      }

      let data = {
        pemilikRekening: this.pemilikRekening,
        noRekening: this.noRekening,
        bank: this.bank,
      };
      this.updateBank(data);
    },
  },
};
</script>

<style scoped src="../styleScope.css"></style>

<style scoped>
.form-field {
  height: 85vh;
}

.btn-save {
  position: fixed;
  width: 90%;
  bottom: 65px;
}
</style>
